/* ============
 * packageUnitType Module Mutations
 * ============
 */

import {
  FETCH_ALL_PACKAGES,
} from './../../mutation-types';

export default {
  [FETCH_ALL_PACKAGES](state, packages) {
    state.all = packages;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/package/mutations.js